import r from "react";
import { useTheme as l, Typography as d } from "@mui/material";
import { f as h, a as s, b as g } from "./chunk.c8qEmHVY.js";
const y = [
  "display1",
  "display2",
  "display3",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "subtitle1",
  "subtitle2",
  "body1",
  "body2",
  "button",
  "caption",
  "overline"
], b = [
  "display100",
  "display200",
  "display300",
  "display400",
  "heading100",
  "heading200",
  "heading300",
  "heading400",
  "heading500",
  "heading600",
  "subtitle100",
  "subtitle200",
  "subtitle300",
  "subtitle400",
  "body100",
  "body200",
  ...y
], m = (t) => {
  var a;
  const e = l(), i = (a = e.typography[t.variant]) == null ? void 0 : a.fontWeight, n = () => {
    if (t.color)
      return t.color;
    switch (t.variant) {
      case "caption":
      case "overline":
        return e.palette.grey[600];
      default:
        return e.palette.grey[900];
    }
  }, o = () => {
    switch (t.fontWeight) {
      case "bold":
        return g;
      case "semiBold":
        return s;
      case "regular":
        return h;
      default:
        return i;
    }
  };
  return /* @__PURE__ */ r.createElement(
    d,
    {
      variant: t.variant,
      sx: {
        color: n()
      },
      align: t.align,
      id: t.id,
      "data-testid": t["data-testid"],
      fontWeight: o(),
      fontStyle: t.fontWeight === "italic" ? "italic" : "normal"
    },
    t.children
  );
};
export {
  m as T,
  y as d,
  b as t
};
